import api from "src/apis/api"

export async function fetchDocumentSettings() {
  const { data } = await api.get("/api/v1/document_settings")
  return data.config
}

export async function updateDocumentSettings(config) {
  const { data } = await api.patch("/api/v1/document_settings", { config })
  return data.config
}

export async function generateQuotation(payload) {
  // payload: { booking_id } OR { deal_id, unit_id, cost_sheet }
  const { data } = await api.post("/api/v1/collections/quotation", payload)
  return data
}

// Prefill for the pre-booking quote composer: the deal's negotiated value, its
// linked unit, and the project's sellable units (each with price_components + CLP).
export async function fetchQuotationContext(dealId) {
  const { data } = await api.get("/api/v1/collections/quotation_context", {
    params: { deal_id: dealId },
  })
  return data
}
